export const BRAND = {
  // Theme aligned to src/images/logo.png (blue + green + white)
  blue: "#2f55a4",
  blueDeep: "#203c7c",
  blueLight: "#e6eeff",
  green: "#8cc63f",
  greenDeep: "#6fae2e",
  greenLight: "#f1fbe6",
  slate: "#334155",
  slateLight: "#f8fafc",
  slateDeep: "#0b1f3a",
  white: "#ffffff",
  accent: "#e6eeff",
};

export default BRAND;
